import { useMemo } from "react";
import { sortBy } from "Shared/util/array";
import { usePayoutInformationContext } from "../../context";
import { CardProps, ConsentItem } from "../card";

export const useCardItems = (onCardClick: CardProps["onClick"]) => {
    const {
        values: { bankConsents },
    } = usePayoutInformationContext();

    return useMemo((): CardProps[] => {
        const cardProps = bankConsents.map((bankConsent): CardProps => {
            const {
                accounts,
                bank: {
                    id: bankId,
                    bic,
                    externalBankId: affiliatedBankId,
                    name: bankName,
                },
                inProgressConsentIds,
            } = bankConsent;

            const consents: ConsentItem[] = accounts.map((account) => ({
                accountNumber: account.accountNumber,
                customerPaymentMethodId: account.customerPaymentMethodId,
                expiresAt: account.consentExpiresAt,
                openBankingAccountId: account.openBankingAccountId,
                status: account.consentStatus,
            }));

            const sortedConsents = sortBy(consents, "accountNumber");

            return {
                affiliatedBankId: affiliatedBankId,
                bankName: bankName,
                bankId: bankId,
                bic,
                consents: sortedConsents,
                hasPendingConsents: inProgressConsentIds?.length > 0,
                onClick: onCardClick,
            };
        });

        const sortedCardProps = sortBy(cardProps, "bankName");

        return sortedCardProps;
    }, [bankConsents, onCardClick]);
};
